import React, { useEffect, useState } from "react";
import Icon from "../assets/images/icon.png";
import FilterBar from "../common/FilterBar";
import CommonCollapsibleTable from "../common/CommonCollapsibleTable";
import { Col, Container, Row, Button, ButtonGroup } from "react-bootstrap";
import Page from "./Page";
import { fetchFlashData } from "../redux/actions/flashActions";
import Loader from "./comman/Loader";

const Flash = () => {
  const [filters, setFilters] = useState({
    startDate: new Date(),
    endDate: new Date(),
    selectedMaterials: [],
    selectedTypes: [],
    selectedSizes: [],
    selectedCities: [],
    selectedBrands: [],
    selectedMarketplaces: ["Amazon"],
    selectedAvailability: [],
  });

  const getAppliedFilters = () => {
    const {
      selectedMaterials,
      selectedTypes,
      selectedSizes,
      selectedCities,
      selectedBrands,
      selectedMarketplaces,
      selectedAvailability,
    } = filters;

    const allFilters = [
      ...selectedMaterials,
      ...selectedTypes,
      ...selectedSizes,
      ...selectedCities,
      ...selectedBrands,
      ...selectedMarketplaces,
      ...selectedAvailability,
    ];

    return allFilters.length > 0 ? allFilters.join(", ") : "No filters applied";
  };

  const [brands, setBrands] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalPages, setTotalpages] = useState(1);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);

      const result = await fetchFlashData(currentPage, itemsPerPage, filters);


      if (result.success) {
        setBrands(result.data.brands);
        setTableData(result.data.tableData);
        setTotalpages(result.data.totalPages);
      } else {
        setError(result.error);
      }

      setLoading(false);
    };

    loadData();
  }, [currentPage, itemsPerPage, filters]);
  useEffect(() => {
    setCurrentPage(1);
  }, [filters]);

  const handlePrevPage = () =>
    currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNextPage = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);

  return (
    <Page title={"Dashboard"} subtitle={"Average Delivery Speed (in days)"}>
      <Container>
        <Row>
          <Col md={12}>
            <div className="my-3">
              <FilterBar filters={filters} setFilters={setFilters} />
            </div>
          </Col>
          <Col md={12}>
            <div className="alert alert-light py-2 px-3 mb-2 border">
              <strong>Applied Filters:</strong> {getAppliedFilters()}
            </div>
          </Col>

          <Col md={12}>
            <hr className="my-4" style={{ color: "#666666" }} />
          </Col>

          {loading ? (
            <Col md={12} className="text-center">
              <Loader />
            </Col>
          ) : error ? (
            <Col md={12} className="text-center text-danger">
              <p>No data available</p>
            </Col>
          ) : (
            <>
              <Col md={12}>
                <div className="d-flex flex-wrap justify-content-between align-items-center text-center">
                  {brands.map((brand, index) => (
                    <div
                      key={brand.name}
                      className={
                        index === 0 || index === brands.length - 1
                          ? "py-0 pe-3"
                          : "py-2 pe-0"
                      }
                    >
                      <h3 className="mb-1 brandnumber">{brand.share}</h3>
                      <p className="brandtext mb-0">
                        {brand.name.charAt(0).toUpperCase() +
                          brand.name.slice(1)}
                      </p>
                    </div>
                  ))}
                </div>
              </Col>

              <Col md={12}>
                <img
                  src={Icon}
                  alt=""
                  className="img-fluid w-100 mt-3"
                  style={{ objectFit: "contain" }}
                />
              </Col>

              <Col md={12}>
                <CommonCollapsibleTable data={tableData} header={brands} />
              </Col>

              {/* Pagination controls */}
              <Col md={12} className="mt-3 d-flex justify-content-center">
                <ButtonGroup>
                  <Button
                    variant="outline-secondary"
                    onClick={handlePrevPage}
                    disabled={currentPage === 1 || loading}
                  >
                    Previous
                  </Button>
                  <Button variant="light" disabled>
                    Page {currentPage} of {totalPages}
                  </Button>
                  <Button
                    variant="outline-secondary"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages || loading}
                  >
                    Next
                  </Button>
                </ButtonGroup>
              </Col>
            </>
          )}
        </Row>
      </Container>
    </Page>
  );
};

export default Flash;
